module.exports = __webpack_public_path__ + "img/禁用.68578b65.svg";